import { colors } from '@creditornot/cb-ingredients';
import { cssThemedValue } from '@creditornot/cb-sc-utils';
import React from 'react';
import styled from 'styled-components';

import { ModalLayout } from './ModalLayout';
import { VenueRowProps, VenueSelectItem } from './types';
import { useSearchVenues } from './useSearchVenues';

type ViewModalContentProps<T> = {
  selectedVenueIds: string[];
  venueSelectItems: VenueSelectItem<T>[];
  rowRenderer: (props: VenueRowProps<T>) => React.ReactNode;
  onClose(): void;
};

const VenueListWrapper = styled.div`
  overflow-y: auto;
  max-height: 600px;
  display: flex;
  flex-direction: column;
`;

const ListRow = styled.label`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const VenueList = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 300px;
  > ${ListRow} {
    padding: 8px 16px;
    border-block-end: 1px solid ${cssThemedValue({ light: colors.pepper8, dark: colors.salt12 })};
  }
`;

export const ViewModalContent = <T,>({ venueSelectItems, onClose, rowRenderer }: ViewModalContentProps<T>) => {
  const { searchValue, setSearchValue, venues: filteredVenueSelectItems } = useSearchVenues(venueSelectItems);
  return (
    <ModalLayout onClose={onClose} searchValue={searchValue} setSearchValue={setSearchValue}>
      <VenueListWrapper>
        <VenueList>
          {filteredVenueSelectItems.map(venueSelectItem => (
            <ListRow key={venueSelectItem.id}>{rowRenderer({ venueSelectItem, searchValue })}</ListRow>
          ))}
        </VenueList>
      </VenueListWrapper>
    </ModalLayout>
  );
};
